/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const handleAuthorizationResponseRequestSchema = z.object({
  instanceId: z.string().nullish(),
  returnUrl: z.string(),
});
